import React, { useState } from "react"
import styled from "styled-components"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps"
import { H4, BigContainer, BackgroundContainer } from "../general/GeneralStyles"
import Location from "./Location"

const Addresses = [
  [
    {
      pretitle: "Global Headquarters",
      title: "Dixon Ticonderoga Company",
      address:
        "615 Crescent Executive Court, Suite 500 </br> Lake Mary, FL 32746",
      phone: "1-800-824-9430",
      fax: "1-800-232-9396",
      email: "customerservice@dixonusa.com",
      lat: 28.761844,
      lng: -81.359867,
    },
    {
      pretitle: "Distribution Center",
      title: "Dixon Ticonderoga Company",
      address:
        "723 Joe Tamplin Industrial Blvd. </br> Building 2 </br> Macon, GA 31217",
      lat: 32.801516,
      lng: -83.567159,
    },
    {
      title: "Dixon Ticonderoga, Inc.",
      address:
        "1310 Kerrisdale Blvd. </br> Unit 1 Suite 200 </br> Newmarket, Ontario L3Y8V6",
      phone: "1-905-895-5122",
      fax: "1-905-895-9555",
      email: "orders@dixoncanada.com",
      link: "www.dixoncanada.com",
      lat: 44.072955,
      lng: -79.430593,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "Canson Inc.",
      address: "21 Industrial Drive</br>South Hadley, MA 01075",
      phone: "1-413-538-9250",
      link: "www.canson.com",
      lat: 42.218974,
      lng: -72.5637354,
    },
    {
      pretitle: "Global Headquarters",
      title: "Pacon Corporation",
      address: "2525 North Casaloma Drive </br>Appleton, WI 54913-8865",
      phone: "1-800-333-2545",
      fax: "1-800-332-5099",
      link: "https://pacon.com",
      lat: 44.286055,
      lng: -88.4810237,
    },
  ],
  [
    {
      pretitle: "Production and Sales Branch",
      title: "Grupo F.I.L.A.- Dixon, S.A. de C.V.",
      address:
        "Autopista México-Querétaro Km 33.5, </br> n. 104, Lecheria, Tultitlán, <br> Estado de México 54940",
      phone: "+52 (55) 5864 7900",
      link: "https://www.dixon.mx",
      lat: 19.648891,
      lng: -99.1984195,
    },
    {
      pretitle: "Sales Branch",
      title: "Canson Brasil",
      address:
        "Rod. SP 73, nº4509 Bl. 04, Distrito Industria </br> CEP 13347.390 Indaiatuba SP",
      lat: -23.1358132,
      lng: -47.2688597,
    },
    {
      pretitle: "Sales Branch",
      title: "F.I.L.A. Chile Ltda",
      address:
        "San Ignacio 300, Bodega C, Quilicura, </br> CP 8710030, Santiago de Chile",
      lat: -33.3307997,
      lng: -70.7054863,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Argentina S.A.",
      address:
        "La Calandria 465 Villa Adelina – </br>San Isidro – Prov. Buenos Aires",
      lat: -34.5080479,
      lng: -58.5428509,
    },
  ],
  [
    {
      pretitle: "Global Headquarters",
      title: "F.I.L.A. S.p.A. Milan",
      address:
        "F.I.L.A. Fabbrica Italiana Lapis ed Affini </br> S.p.A. – Via XXV Aprile 5, 20016 Pero",
      phone: "+39 02 38105.1",
      fax: " +39 02 3538546",
      email: "fila@fila.it",
      link: "https://www.filagroup.it/en/",
      lat: 45.5098972,
      lng: 9.088954,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "F.I.L.A. S.p.A. Florence",
      address:
        "F.I.L.A. Fabbrica Italiana Lapis ed Affini  </br> S.p.A. – Via Meucci 2, località Scopeti, Rufina",
      lat: 43.8428188,
      lng: 11.495862,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "Industria Maimeri S.p.A",
      address:
        "Bettolino di Mediglia: Via Gianni Maimeri 1, </br> 20060 Mediglia",
      phone: "+39 02 906981",
      fax: "+39 02 90698999",
      email: "info@maimeri.it",
      link: "https://www.maimeri.it/en",
      lat: 45.4314861,
      lng: 9.3402971,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "Omyacolor S.A.",
      address: "Rue de Marson, 51240 Saint-Germain-La-Ville",
      lat: 48.8825211,
      lng: 4.4518131,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA BENELUX SA",
      address: "Zuiderlaan 14/2, 1731 Zellik",
      lat: 50.8792761,
      lng: 4.2807578,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "CANSON SAS",
      address:
        "67, Rue Louis et Laurent Seguin, CS 70139 <br> 07104 ANNONAY Cedex",
      lat: 45.26077,
      lng: 4.6563341,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "Johann Froescheis Lyra-Bleitstitift-Fabrik GmbH&Co-KG",
      address: "Willstätterstraße 54-56 – 90449 <br> Nuremberg",
      lat: 49.42579,
      lng: 11.0126113,
    },
    {
      pretitle: "Sales Branch",
      title: "Lukas-Nerchau Gmbh",
      address: "Harffstr. 40, Düsseldorf <br> Germany",
      lat: 51.1970291,
      lng: 6.81584,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Hellas SA",
      address: "Anagenniseos 1/757 Block, 57013 Thessaloniki",
      lat: 40.7253302,
      lng: 22.9207419,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Polska Sp. Zo.o",
      address: "UL. Senatorska 18 A/28, 31-106 Krakow",
      lat: 50.0536245,
      lng: 19.9165541,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "Daler-Rowney Ltd.",
      address: "Bracknell, Berkshire <br> RG12 8SS <bv> United Kingdom",
      email: "webmaster@daler-rowney.com",
      link: "http://www.daler-rowney.com/",
      lat: 51.4097086,
      lng: -0.7763556,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "St Cuthberts Mill Ltd",
      address: "Wells, Somerset <br> BA5 1AG <br> United Kingdom",
      phone: "+44 (0)1749 672015",
      fax: "+44 (0)1749 678844",
      email: "sales@stcuthbertsmill.com",
      link: "http://www.stcuthbertsmill.com/",
      lat: 51.2163812,
      lng: -2.6746054,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Stationary O.O.O.",
      address: "Smirnovskaja Street 25, Bld 3 Office 07, 109052, <br> Moscow",
      lat: 55.9784027,
      lng: 37.0409304,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Hispania S.L.",
      address:
        "Parets del Valles, P.I. Autopista Sud Paseo Fluvial 4, <br> Barcelona",
      lat: 41.5480967,
      lng: 2.2316133,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Nordic AB",
      address: "Signalgatan 2, 44240 Kungälv",
      lat: 57.8793423,
      lng: 11.9296251,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Art Products AG",
      address: "Schwimmbadstrasse 45, CH 5430 <br> Wettingen",
      lat: 47.4596279,
      lng: 8.3126564,
    },
    {
      pretitle: "Sales Branch",
      title: "FILA Stationary and Office Equipment Industry Ltd. Co.",
      address:
        "19 Mayıs Mahallesi, Ataturk Cad, Esin Sok, <br> Yazgan Merkezi No: 3/7 – 34736, Istanbul",
      lat: 40.9808744,
      lng: 29.0879065,
    },
  ],
  [
    {
      pretitle: "Production and Sales Branch",
      title: "Canson Pty Ltd Australia",
      address: "13-19 Keysborough Avenue <br> Keysborough VIC 3173",
      lat: -37.9889825,
      lng: 145.14672,
    },
    {
      pretitle: "Sales Branch",
      title: "Beijing F.I.L.A. Dixon Stationery Co. Ltd.",
      address:
        "Room n° 2015, 2017, 2019, Block C., <br> Xijin Plaza, Building #53, Yunjingbeili, <br> Tongzhou District, Beijing",
      lat: 39.8123363,
      lng: 116.600226,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "F.I.L.A. Dixon Stationary (Kunshan) Co., Ltd.",
      address:
        "211, Jiguang Zhonglu, Qiandeng, <br> 215343 Kunshan City, Jiangsu Province",
      lat: 30.6237221,
      lng: 112.6224149,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "Canson Art & Craft Yixing Co.,Ltd",
      address:
        "No 6, Wenzhuang Road, <br> Economic and Technology Development Zone, <br> Yinxing Jiangsu Province",
      lat: 31.399466,
      lng: 119.8686793,
    },
    {
      pretitle: "Sales Branch",
      title: "Xinjiang F.I.L.A. – Dixon Plantation Co. Ltd",
      address:
        "Chabuchaer Xibo Autonomous Country, <br> Yili Kazakstan Autonomous State, <br> Xinjiang Uygur Autonomous Region",
      lat: 43.616764,
      lng: 80.8694613,
    },
    {
      pretitle: "Sales Branch",
      title: "Canson Qingdao Ltd. China",
      address:
        "Room 1003-100, ChangChunTengYunTong Tower <br> 818 West Nanjing Road, Shanghai 200041",
      lat: 31.23122,
      lng: 121.4589953,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "DOMS Industries Pvt Ltd.",
      address:
        "Plot No.32,33,44,45,46, GIDC New Exp. Area, <br> Umbergaon – 396171 Gujarat",
      lat: 20.1446379,
      lng: 72.7666339,
    },
    {
      pretitle: "Production and Sales Branch",
      title: "DOMS Industries Private Limited",
      address:
        "SIDCO. Village- <br> EPIP, Kartholi, Bari-Brahmana, <br> Jammu & Kashmir -181133, India",
      lat: 32.6446909,
      lng: 74.8975388,
    },
    {
      pretitle: "Sales Branch",
      title: "PT. Lyra Akrelux",
      address:
        "JL. Raya Gading Batavia Block LC.8 NO.31, <br> Kelapa Gading Permai, Jakarta, 14240",
      lat: -6.1536997,
      lng: 106.8950039,
    },
    {
      pretitle: "Sales Branch",
      title: "Fila Art and Craft co,Ltd",
      address: "Ha’manim St. <br> Moshav Beni-Zion, 60910",
      lat: 32.2185193,
      lng: 34.8662174,
    },
  ],
]

const RegionsArr = [
  {
    name: "NORTH AMERICA",
    lat: 37.09024,
    lng: -70.84204,
  },
  {
    name: "LATIN AMERICA",
    lat: 15.242049,
    lng: -86.309277,
  },
  {
    name: "EUROPE",
    lat: 54.525963,
    lng: 20.930943,
  },
  {
    name: "ASIA",
    lat: 34.047863,
    lng: 100.619652,
  },
]

const Regions = styled(BigContainer)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  padding-top: 40px;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-template-columns: 1fr;
  }
`

const RegionTitle = styled(H4)`
  border-bottom: 2px solid black;
  cursor: pointer;
  padding-bottom: 10px;
  border-color: ${props =>
    props.active ? props.theme.primaryColor : props.theme.tertiaryTextColor};
  color: ${props =>
    props.active ? props.theme.primaryColor : props.theme.tertiaryTextColor};
  transition: all ease-in-out 0.3s;
`

const MyMapComponent = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap defaultZoom={5} center={{ lat: props.lat, lng: props.lng }}>
      {props.addresses.map((address, index) => (
        <Marker key={index} position={{ lat: address.lat, lng: address.lng }} />
      ))}
    </GoogleMap>
  ))
)
const Locations = styled(BigContainer)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 32px;
  margin-bottom: 120px;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-template-columns: 1fr;
  }
`

const ContactBottomHalf = styled(BackgroundContainer)`
  background: url("/images/bg/ripped-paper.png");
  padding-top: 350px;
  padding-bottom: 10px;
  width: 100vw;
  z-index: 10;
  position: relative;
  top: -50px;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    padding-top: 150px;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    padding-top: 70px;
  }
`

const Map = styled.div`
  position: absolute;
  z-index: 1;
  width: 100vw;
  top: 0;

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    display: none;
  }
`

const ContactContainer = styled.div`
  padding-top: 400px;
  position: relative;

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    padding-top: 0px;
  }
`

const ContactMap = props => {
  const [activeRegion, setActiveRegion] = useState(RegionsArr[0])
  const [activeAddress, setActiveAddress] = useState(Addresses[0])
  const handleRegionClick = (e, index) => {
    setActiveRegion(RegionsArr[index])
    setActiveAddress(Addresses[index])
  }

  const showLocationOnMap = props => {
    setActiveRegion({
      lat: props.lat,
      lng: props.lng,
    })
  }

  return (
    <ContactContainer>
      <Map>
        <MyMapComponent
          isMarkerShown
          googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyBO0zwmgbo9GuUxUCYNfyMnCJLHXaG6CsQ"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `700px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          addresses={activeAddress}
          lat={activeRegion.lat}
          lng={activeRegion.lng}
        />
      </Map>
      <ContactBottomHalf>
        <Regions>
          {RegionsArr.map((region, index) => (
            <RegionTitle
              onClick={e => handleRegionClick(e, index)}
              key={index}
              active={activeRegion.name == region.name}
            >
              {region.name}
            </RegionTitle>
          ))}
        </Regions>
        <Locations>
          {activeAddress.map(location => (
            <Location
              location={location}
              onClick={() => showLocationOnMap(location)}
            />
          ))}
        </Locations>
      </ContactBottomHalf>
    </ContactContainer>
  )
}

export default ContactMap
